module.exports = __webpack_public_path__ + "assets/img/package-default-old.0fb7c72a.svg";